import { createFileRoute } from '@tanstack/react-router';

import { createQueryLoader } from '@/loader';
import StartSubmissionLayoutPageQueryNode, {
  type StartSubmissionLayoutPageQuery,
} from '@/pages/start/__generated__/StartSubmissionLayoutPageQuery.graphql';
import StartSubmissionLayoutPage from '@/pages/start/StartSubmissionLayoutPage';

const loadSubmissionLayout = createQueryLoader<StartSubmissionLayoutPageQuery>(
  StartSubmissionLayoutPageQueryNode,
);

export const Route = createFileRoute('/_authenticated/start/$submissionId')({
  loader: ({ context, params }) =>
    loadSubmissionLayout({
      environment: context.relayEnvironment,
      variables: { submissionId: params.submissionId },
    }),
  component: StartSubmissionLayoutPage,
  shouldReload: false,
});
